import { Box } from '@material-ui/core'
import { TextField } from '@mui/material'
import RegularButton from 'components/CustomButtons/Button'
import { useForm } from 'hooks/useForm'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { postPlatformConditionUnit } from 'redux/actions/unitsSection/unitsAction'
import { putPlatformConditionUnit } from 'redux/actions/unitsSection/unitsAction'

export const AddPlatformCondition = (props) => {
  const {
    data,
    onClose
  } = props
  const platformCondition = data?.platformConditions ? data?.platformConditions[0] : {}

  const dispatch = useDispatch()
  const { inputValues, handleInputOnChange, handleNewValues } = useForm({ 
    allTypes: '',
    cylinder10: '',
    cylinder20: '',
    cylinder30: '',
    cylinder45: '',
    kilograms: '',
    percentage: '', 
  })

  const { 
    allTypes,
    cylinder10, 
    cylinder20, 
    cylinder30, 
    cylinder45, 
    kilograms,
    percentage 
  } = inputValues

  const handleSubmit = () => {
      const body = {
        ...platformCondition,
        idUnit: data?.id,
        allTypes,
        cylinder10, 
        cylinder20, 
        cylinder30, 
        cylinder45, 
        kilograms,    
        percentage,
      }
      if(platformCondition?.id) dispatch(putPlatformConditionUnit(body))
      else dispatch(postPlatformConditionUnit(body));
      setTimeout(() => {
        onClose()
      }, 400)
  }

  useEffect(() => {
    if(platformCondition?.id) {
      handleNewValues({
        ...platformCondition,
        cylinder10: platformCondition?.cylinder10,
        cylinder20: platformCondition?.cylinder20,
        cylinder30: platformCondition?.cylinder30,
        cylinder45: platformCondition?.cylinder45,
        kilograms: platformCondition?.kilograms,
        percentage: platformCondition?.percentage,
      })
    }
    // eslint-disable-next-line 
  }, [platformCondition])

  return (
    <Box style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
      <TextField type="number" label="Cil 10" name="cylinder10" value={cylinder10} onChange={handleInputOnChange} variant="outlined" />
      <TextField type="number" label="Cil 20" name="cylinder20" value={cylinder20} onChange={handleInputOnChange} variant="outlined" style={{ marginTop: 8 }} />
      <TextField type="number" label="Cil 30" name="cylinder30" value={cylinder30} onChange={handleInputOnChange} variant="outlined" style={{ marginTop: 8 }} />
      <TextField type="number" label="Cil 45" name="cylinder45" value={cylinder45} onChange={handleInputOnChange} variant="outlined" style={{ marginTop: 8 }} />
      <TextField type="number" label="Kilogramos" name="kilograms" value={kilograms} onChange={handleInputOnChange} variant="outlined" style={{ marginTop: 8 }} />
      <TextField type="number" label="Porcentaje" name="percentage" value={percentage} onChange={handleInputOnChange} variant="outlined" style={{ marginTop: 8 }} />
      <TextField type="number" label="Cantidad de Tipos" name="allTypes" value={allTypes} onChange={handleInputOnChange} variant="outlined" style={{ marginTop: 8 }} />
      <Box style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 8 }}>
        <RegularButton color="success" onClick={handleSubmit}>Guardar</RegularButton>
        <RegularButton color="danger" onClick={onClose}>Cancelar</RegularButton>
      </Box>
    </Box>
  )
}
